/**
 * Generates pacing text based on the pacing type
 * @param pacing - The pacing type ("self_paced", "instructor_paced", or custom string)
 * @returns Formatted pacing text or null if data is not available
 */
export function getPacingText(
  pacing?: "self_paced" | "instructor_paced" | string,
): string | null {
  if (!pacing) return null;

  if (pacing === "self_paced") {
    return "Self-paced";
  } else if (pacing === "instructor_paced") {
    return "Instructor-paced";
  } else {
    return pacing;
  }
}
